import { initializeApp } from 'firebase/app';

/** MoneyLens web app — Firebase console (moneylensai-7eac7). */
export const firebaseConfig = {
  apiKey: 'AIzaSyCEZzJUcYzRr1WN_brH2UUPpQoIuae6DFs',
  authDomain: 'moneylensai-7eac7.firebaseapp.com',
  projectId: 'moneylensai-7eac7',
  storageBucket: 'moneylensai-7eac7.firebasestorage.app',
  messagingSenderId: '666796012347',
  appId: '1:666796012347:web:9fd1426f5595c39786bd1e',
  measurementId: 'G-1JEZ65HW06',
};

export const firebaseApp = initializeApp(firebaseConfig);

type AnalyticsApi = typeof import('./firebaseAnalytics.web');

type LoadedAnalytics = {
  analytics: ReturnType<AnalyticsApi['getAnalytics']>;
  api: AnalyticsApi;
};

let analyticsReady: Promise<LoadedAnalytics | null> | null = null;

/** Loads Firebase Analytics on first call. HTML gtag is Google Ads only. */
export function loadWebAnalytics(): Promise<LoadedAnalytics | null> {
  if (!analyticsReady) {
    analyticsReady = import(
      /* webpackChunkName: "firebase-analytics" */ './firebaseAnalytics.web'
    )
      .then(async (api) => {
        const supported = await api.isSupported();
        if (!supported) return null;
        const analytics = api.initializeAnalytics(firebaseApp, {
          config: { send_page_view: false },
        });
        return { analytics, api };
      })
      .catch((error: unknown) => {
        console.warn('[firebase] Analytics unavailable', error);
        return null;
      });
  }
  return analyticsReady;
}

export async function getWebAnalytics(): Promise<LoadedAnalytics['analytics'] | null> {
  const loaded = await loadWebAnalytics();
  return loaded?.analytics ?? null;
}
